import label from './pictorialBar.emphasis.label'
import itemStyle from './pictorialBar.emphasis.itemStyle'

export default {
  name: "emphasis",
  nickname: "高亮",
  desc: "emphasis",
  type: "object",
  props: {
    label,
    itemStyle,
  },
}
